/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';

import { PhoneMFAForm } from './PhoneMFAForm';
import { EmailMFAForm } from './EmailMFAForm';

export namespace SetupMFAPage {
  export interface Props {}
}

export const SetupMFAPage: React.FC<SetupMFAPage.Props> = () => {
  const [useEmailMFA, setUseEmailMFA] = useState(false);

  return useEmailMFA ? (
    <EmailMFAForm setUseEmailMFA={setUseEmailMFA} />
  ) : (
    <PhoneMFAForm setUseEmailMFA={setUseEmailMFA} />
  );
};
